import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/data";

export const Services = () => {
  return (
    <section
      id="services"
      className="py-24 lg:py-32 bg-secondary/40 border-y border-border"
      data-testid="services-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="overline text-accent mb-6">02 / What We Stock</p>
            <h2 className="font-display text-4xl sm:text-6xl leading-none tracking-tight text-foreground max-w-2xl">
              Aisles for every <em className="italic text-accent">everyday</em> need.
            </h2>
          </div>
          <p className="text-muted-foreground max-w-sm text-base leading-relaxed">
            From the morning milk to the monthly ration — restocked daily and
            priced fairly for the families of Dabok.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 auto-rows-[minmax(260px,auto)]">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden bg-foreground ${s.span}`}
              data-testid={`service-card-${i}`}
            >
              <img
                src={s.image}
                alt={s.title}
                className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-105 group-hover:opacity-100 transition-[transform,opacity] duration-700 ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="relative h-full min-h-[260px] p-7 flex flex-col justify-between">
                <div className="flex items-center justify-between">
                  <span className="overline text-white/80">{s.tag}</span>
                  <span className="w-9 h-9 rounded-full border border-white/40 flex items-center justify-center text-white translate-y-1 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
                    <ArrowUpRight size={16} />
                  </span>
                </div>
                <div>
                  <h3 className="font-display text-3xl sm:text-4xl text-white leading-none tracking-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-white/70 text-sm leading-relaxed max-w-md max-h-0 overflow-hidden group-hover:max-h-24 transition-[max-height] duration-500">
                    {s.desc}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
